import {areDevAssertionsEnabled} from '@PosterWhiteboard/libraries/dev-assertions';

export class CommonMethods {
  protected ignoreKeysForCopy: Record<string, null> = {};
  public copyVals(obj: Record<string, any> = {}): void {
    for (const [key, value] of Object.entries(obj)) {
      if (this.ignoreKeysForCopy[key] === undefined && this[key as keyof typeof this] !== value) {
        if (areDevAssertionsEnabled()) {
          this.#warnIfClobberingNestedInstance(key, value);
        }
        this[key as keyof typeof this] = value;
      }
    }
  }

  /**
   * The reflective assign above cannot tell a class instance from plain data: forget to
   * destructure a nested composite (effects, cropData, textStyles, ...) out of an incoming
   * object and the instance is silently replaced by a methodless plain object, crashing far
   * from the cause. Detect exactly that case and report it at the point of corruption.
   */
  #warnIfClobberingNestedInstance(key: string, incoming: unknown): void {
    const current = this[key as keyof typeof this];
    if (current instanceof CommonMethods && typeof incoming === 'object' && incoming !== null && !(incoming instanceof CommonMethods)) {
      console.error(
        `copyVals is replacing the '${key}' ${current.constructor.name} instance on ${this.constructor.name} with a plain object — its methods will vanish. ` +
          `Destructure '${key}' out and delegate to that object's own copyVals/update path instead.`
      );
    }
  }
}
